import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import action from "../../Redux Store/actions";

import EarningsSummaryCard from "./EarningsSummaryCard";
import BookingsLadderCard from "./BookingsLadderCard";
import SiteVisitTrackingTable from "./SiteVisitTrackingTable";
import { bookingsLadder } from "./mockDashboardData";

const axiosInstance = axios.create({
  baseURL: "https://sandboxrnl.vjoneparivaar.com/api",
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

const FosDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedInUser = useSelector((state) => state.Auth.user);
  const fosId = loggedInUser?.fosId;

  const [allQuarters, setAllQuarters] = useState([]);
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [actualCurrentIdx, setActualCurrentIdx] = useState(-1);
  const [dashboardLoading, setDashboardLoading] = useState(true);

  const currentQuarter = allQuarters[selectedIdx] || null;
  const prevQuarter = selectedIdx > 0 ? allQuarters[selectedIdx - 1] : null;

  const isVisible =
    loggedInUser?.type === "FOS" && loggedInUser?.isWalletVisible === true;

  useEffect(() => {
    if (!isVisible) navigate("/Home", { replace: true });
  }, [isVisible, navigate]);

  useEffect(() => {
    dispatch(action.activeMenu("home"));
  }, [dispatch]);

  useEffect(() => {
    if (!fosId) return;
    axiosInstance
      .get(`/fosWallet/fos-dashboard-summary?fos_id=${fosId}`)
      .then((res) => {
        if (!res.data?.success) return;
        const quarters = res.data.data.quarters || [];
        const today = new Date();
        const currentIdx = quarters.findIndex(
          (q) => today >= new Date(q.start_date) && today <= new Date(q.end_date)
        );
        const defaultIdx = currentIdx !== -1 ? currentIdx : quarters.length - 1;
        setAllQuarters(quarters);
        setActualCurrentIdx(currentIdx);
        setSelectedIdx(defaultIdx);
      })
      .catch((err) => console.error("FosDashboard fetch error:", err))
      .finally(() => setDashboardLoading(false));
  }, [fosId]);

  if (!isVisible) return null;

  return (
    <Box p={3} sx={{ bgcolor: "#f5f7fa", height: "100vh", overflowY: "auto", pb: { xs: "500px", md: "100px" } }}>

      <Box
        sx={{
          display: { xs: "flex", md: "grid" },
          flexDirection: "column",
          gridTemplateColumns: { md: "5fr 7fr" },
          gap: 3,
          mb: 3,
        }}
      >
        <EarningsSummaryCard
          currentQuarter={currentQuarter}
          prevQuarter={prevQuarter}
          dashboardLoading={dashboardLoading}
          allQuarters={allQuarters}
          selectedIdx={selectedIdx}
          onQuarterChange={setSelectedIdx}
          actualCurrentIdx={actualCurrentIdx}
        />
        <BookingsLadderCard data={bookingsLadder} currentQuarter={currentQuarter} dashboardLoading={dashboardLoading} />
      </Box>

      <Box sx={{ mt: { xs: 3, lg: 0 }, mb: { xs: 26, lg: 0 } }}>
        <SiteVisitTrackingTable
          siteVisitSummary={currentQuarter?.site_visit_summary || []}
          siteVisitCounts={currentQuarter?.site_visit_counts || null}
        />
      </Box>
    </Box>
  );
};

export default FosDashboard;
